module.exports = __webpack_public_path__ + "static/img/ys67.014c5ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ys67.png
// module id = +2+A
// module chunks = 73